import { DOM_IDS } from './constants.js'
import { getBrandColorVariants } from '../utils/brand-color.js'
const HEADER_INNER_SELECTOR = '.frame-common-header'
const FOOTER_LINK_WRAPPER = '.footer-copyright .legal-links-wrapper'
const THEME_DEFAULTS = {
  backgroundColor: '#FFFFFF',
  textColor: 'var(--zoom-color-icon-strong-neutral)'
}

export function applyHeaderTheme(style = {}) {
  const root = document.getElementById(DOM_IDS.HEADER_CONTAINER)
  const headerEl = root?.querySelector(HEADER_INNER_SELECTOR)
  if (!headerEl) return

  const hasCustomBackground = Boolean(style?.backgroundColor)
  headerEl.style.backgroundColor = hasCustomBackground
    ? style.backgroundColor
    : THEME_DEFAULTS.backgroundColor
  headerEl.style.color = hasCustomBackground ? style.textColor : THEME_DEFAULTS.textColor

  const colorVars = getBrandColorVariants(style.textColor)
  if (colorVars) {
    headerEl.style.setProperty('--zoom-color-state-primary-hover', colorVars.hover)
    // headerEl.style.setProperty('--zoom-color-icon-strong-neutral', colorVars.hover)
    const waffleBtn = headerEl.querySelector('.header-waffle-icon')
    if (waffleBtn) {
      waffleBtn.style.setProperty('--zoom-color-state-primary-hover', colorVars.hover)
    }
    const drivenEl = headerEl.querySelector('.frame-common-header__logo-text')
    if (drivenEl) {
      drivenEl.style.setProperty('--zoom-color-border-subtle-neutral', colorVars.borderSubtle)
    }
    const ToggleEl = headerEl.querySelector('.new-experience-toggle')
    if (ToggleEl) {
      ToggleEl.style.setProperty('--zoom-color-border-subtle-neutral', colorVars.borderSubtle)
    }
  }
}

export function applyFooterTheme(style = {}) {
  const root = document.getElementById(DOM_IDS.SIMPLIFIED_FOOTER_COPYRIGHT)
  const linkWrapperEl = root?.querySelector(FOOTER_LINK_WRAPPER)
  if (!linkWrapperEl) return

  const footerColorVars = getBrandColorVariants(style.textColor)
  if (footerColorVars) {
    linkWrapperEl.style.setProperty(
      '--zoom-color-border-subtle-neutral',
      footerColorVars.borderSubtle
    )
  }
}
